import React from 'react';
import { Create } from 'react-admin';
import TemplateForm from './form';

const TemplateCreate = (props) => {
  const { resource } = props;

  return (
    <Create title={`resources.${resource}.titles.create`} {...props}>
      <TemplateForm/>
    </Create>
  );
};

export default TemplateCreate;
